import React, {useState, useEffect, useCallback, useRef} from 'react';
import {Card, Typography, Statistic, message, Button, Drawer, Splitter, Modal} from 'antd';
import TesterPaginator from "../components/Tester/TesterPaginator";
import {useParams, useNavigate} from "react-router-dom";
import axios from "axios";
import {API_BASE_URL} from "../config";
import MathText from "../components/MathText";
import StartModal from "../components/Tester/StartModal";
import FinishModal from "../components/Tester/FinishModal";
import ReviewModal from "../components/Tester/ReviewModal";
import {CloseOutlined, LeftOutlined, RightOutlined} from "@ant-design/icons";
import MathAnswerInput from "../components/MathAnswerInput";

const {Text} = Typography;
const {Countdown} = Statistic;

// [NEW] Har bir step uchun ajratilgan vaqt (daqiqada)
const STEP_MINUTES = {1: 32, 2: 32, 3: 35, 4: 35};
// [NEW] Pauza uzunligi (ms)
const STEP_BREAK_MS = 10000;

const MODULE_TITLES = {
    1: 'Module 1',
    2: 'Module 2',
    3: 'Module 1',
    4: 'Module 2'
}

const answerTransform = {variant1: "A", variant2: "B", variant3: "C", variant4: "D"};

const SatCollectionTest = () => {
    const {id} = useParams();
    const navigate = useNavigate();


    const [step, setStep] = useState(() => {
        const savedStep = localStorage.getItem('step');
        return savedStep ? JSON.parse(savedStep) : 1;
    });
    const scrollRef = useRef(null);
    const finishingRef = useRef(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 900);

    const [pages, setPages] = useState([]);
    const [questions, setQuestions] = useState(() => {
        const saved = JSON.parse(localStorage.getItem('steps') || '{}');
        return saved?.[step] ?? {};
    });
    const [current, setCurrent] = useState(() => {
        const saved = Number(localStorage.getItem('selectedPageKey'));
        return Number.isFinite(saved) && saved > 0 ? saved : 1;
    });

    useEffect(() => {
        const len = questions ? Object.keys(questions).length : 0;
        const savedIdx = parseInt(localStorage.getItem('selectedPageKey') || '1', 10);
        const next = questions[savedIdx] ? savedIdx : 1;
        if (current !== next) setCurrent(next);

        const pageData = Array.from({length: len}, (_, i) => ({
            key: i + 1,
            id: questions[i + 1]?.id,
        }));
        setPages(pageData);
        setCurrentQuestion(questions[next]);
        setSplit(questions[next]?.split ?? false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [questions, current]);

    const [split, setSplit] = useState(false);
    const [currentQuestion, setCurrentQuestion] = useState();
    const [answers, setAnswers] = useState(() => {
        const savedAnswers = localStorage.getItem('answers');
        return savedAnswers ? JSON.parse(savedAnswers) : {};
    });

    // Start modal: true => hali boshlanmagan
    const [modalVisible, setModalVisible] = useState(() => {
        const savedModalVisible = localStorage.getItem('modalVisible');
        return savedModalVisible ? JSON.parse(savedModalVisible) : true;
    });

    const [reviewOpen, setReviewOpen] = useState(false);
    const [finishModalVisible, setFinishModalVisible] = useState(false);
    const [finishMessage, setFinishMessage] = useState("Vaqtingiz tugadi! Natija telegram orqali yuboriladi!");

    // [CHANGED] deadline — faqat JORIY STEP uchun
    const [deadline, setDeadline] = useState(undefined);

    // Mobile left panel text Drawer
    const [textOpen, setTextOpen] = useState(false);
    const handleTextOpen = () => setTextOpen(true);

    const [doneSteps, setDoneSteps] = useState(() => {
        try {
            return JSON.parse(localStorage.getItem('doneSteps') || '[]');
        } catch {
            return [];
        }
    });
    useEffect(() => {
        localStorage.setItem('doneSteps', JSON.stringify(doneSteps));
    }, [doneSteps]);

    // [NEW] Steplar orasidagi 5s pauza
    const [breakOpen, setBreakOpen] = useState(false);
    const [breakUntil, setBreakUntil] = useState(null);
    const [pendingStep, setPendingStep] = useState(null); // break tugagach o‘tiladigan step
    const [breakInfo, setBreakInfo] = useState({count: 0, minutes: 0, step: 0});

    // Resize paytida haddan tashqari re-renderni oldini olish
    const isMobilePrevRef = useRef(window.innerWidth < 900);
    const rafRef = useRef(null);
    useEffect(() => {
        const onResize = () => {
            if (rafRef.current) return;
            rafRef.current = requestAnimationFrame(() => {
                rafRef.current = null;
                const next = window.innerWidth < 900;
                // Faqat breakpoint (900px) chiziqdan o'tganda state yangilaymiz
                if (next !== isMobilePrevRef.current) {
                    isMobilePrevRef.current = next;
                    setIsMobile(next);
                }
            });
        };
        window.addEventListener("resize", onResize);
        return () => {
            window.removeEventListener("resize", onResize);
            if (rafRef.current) cancelAnimationFrame(rafRef.current);
        };
    }, []);

    // Boshlanmagan bo‘lsa UI ni tozalash (deadline ko‘rinmasin)
    useEffect(() => {
        if (modalVisible) {
            setDeadline(undefined);
        }
    }, [modalVisible]);

    // LocalStorage: answers/step
    useEffect(() => {
        localStorage.setItem('answers', JSON.stringify(answers));
    }, [answers]);
    useEffect(() => {
        localStorage.setItem('step', JSON.stringify(step));
    }, [step]);

    // Savollarni bir marta (yoki kerak bo‘lsa) yuklab kelish
    useEffect(() => {
        const fetchQuestions = async () => {
            try {
                const token = localStorage.getItem("token");
                const {data} = await axios.get(
                    `${API_BASE_URL}/api/SatTest?CollectionId=${id}`,
                    {headers: {Authorization: `Bearer ${token}`}}
                );

                // 1) Steplar bo‘yicha
                const byStep = {
                    1: data.filter((item) => item.step === "1"),
                    2: data.filter((item) => item.step === "2"),
                    3: data.filter((item) => item.step === "3"),
                    4: data.filter((item) => item.step === "4"),
                };

                // 2) UI format
                const transformeds = {1: {}, 2: {}, 3: {}, 4: {}};
                Object.entries(byStep).forEach(([k, arr]) => {
                    arr.forEach((item, i) => {
                        transformeds[Number(k)][i + 1] = item;
                    });
                });

                // 3) Qaysi stepdan start? — bo‘sh bo‘lmasa hozirgi, bo‘lsa navbatdagisi
                const has = (k) => Object.keys(transformeds[k] || {}).length > 0;
                const startStep = [1, 2, 3, 4].find((k) => has(k)) ?? 1;   // <- eng kichik mavjud step

                if (startStep !== step) setStep(startStep);

                // UI uchun tanlangan stepni qo‘yish
                const q = transformeds[startStep] ?? {};
                setQuestions(q);
                const savedIdx = parseInt(localStorage.getItem('selectedPageKey') || '1', 10);
                const next = q[savedIdx] ? savedIdx : 1;
                setCurrent(next);
                setCurrentQuestion(q[next]);
                setSplit(q[next]?.split ?? false);

                // hammasini LS ga yozamiz
                localStorage.setItem("steps", JSON.stringify(transformeds));
                localStorage.setItem('modalVisible', JSON.stringify(modalVisible));
            } catch (err) {
                message.error("Error fetching questions");
                setQuestions({});
                setCurrent(1);
                setCurrentQuestion(undefined);
                setSplit(false);
            }
        };

        // faqat start modal yopilgandan keyin fetch qilinsin degan shart oldin ham bor edi;
        // hozir ham shuni saqlaymiz:
        const savedSteps = JSON.parse(localStorage.getItem('steps') || '{}');
        const haveAny = [1, 2, 3, 4].some(k => savedSteps?.[k] && Object.keys(savedSteps[k]).length > 0);
        if (!modalVisible && !haveAny) {
            fetchQuestions();
        } else if (haveAny) {
            // sahifa qayta ochilganda ham eng kichik mavjud stepdan boshlaymiz
            const first = [1, 2, 3, 4].find(k => savedSteps[k] && Object.keys(savedSteps[k]).length > 0) || 1;
            const stepHasQs = savedSteps[step] && Object.keys(savedSteps[step]).length > 0;
            const effectiveStep = stepHasQs ? step : first;
            if (effectiveStep !== step) setStep(effectiveStep);
            const q = savedSteps[effectiveStep] ?? {};
            setQuestions(q);
            const savedIdx = parseInt(localStorage.getItem('selectedPageKey') || '1', 10);
            const next = q[savedIdx] ? savedIdx : 1;
            setCurrent(next);
            setCurrentQuestion(q[next]);
            setSplit(q[next]?.split ?? false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modalVisible]);

    // [NEW] — joriy step uchun deadline yaratish/olish
    const ensureDeadlineForStep = useCallback((s) => {
        if (!s) return;
        if (modalVisible) return;             // start bosilmagan bo‘lsa yo‘q
        if (breakOpen) return;                // pauza paytida yo‘q
        const key = `deadline_s${s}`;
        const saved = localStorage.getItem(key);
        if (saved) {
            setDeadline(JSON.parse(saved));
            return;
        }
        const ms = (STEP_MINUTES[s] || 30) * 60 * 1000;
        const d = Date.now() + ms;
        localStorage.setItem(key, JSON.stringify(d));
        setDeadline(d);
    }, [modalVisible, breakOpen]);

    // [IMPORTANT] — step yoki start holati o‘zgarsa: faqat test boshlangan bo‘lsa deadline yaratamiz
    useEffect(() => {
        if (!modalVisible) {
            ensureDeadlineForStep(step);
        }
    }, [step, modalVisible, ensureDeadlineForStep]);


    const scrollLeft = () => {
        if (scrollRef.current) {
            scrollRef.current.scrollBy({left: -150, behavior: 'smooth'});
        }
    };
    const scrollRight = () => {
        if (scrollRef.current) {
            scrollRef.current.scrollBy({left: 150, behavior: 'smooth'});
        }
    };

    const cleanupLocalStorage = useCallback(() => {
        localStorage.removeItem('steps');
        localStorage.removeItem('answers');
        localStorage.removeItem('modalVisible');
        localStorage.removeItem('selectedPageKey');
        localStorage.removeItem('step');
        [1, 2, 3, 4].forEach(s => localStorage.removeItem(`deadline_s${s}`));
        localStorage.removeItem('doneSteps');
        setDoneSteps([]);
    }, []);

    const handleFinish = useCallback(async () => {
        if (finishingRef.current) return;
        finishingRef.current = true;

        const savedAnswers = localStorage.getItem('answers');
        const ans = savedAnswers ? JSON.parse(savedAnswers) : {};
        const answersPayload = Object.keys(ans).map((qid) => ({
            satQuestionId: parseInt(qid, 10),
            answer: answerTransform[ans[qid]] || ans[qid] || ""
        }));
        try {
            const token = localStorage.getItem("token");
            const {data} = await axios.post(
                `${API_BASE_URL}/api/SatResult`,
                {
                    satCollectionId: String(id),
                    answers: answersPayload
                },
                {
                    headers: {
                        accept: "*/*",
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json"
                    }
                }
            );
            // tozalash
            cleanupLocalStorage();

            // redirect to result page
            if (data?.id) {
                navigate(`/sat-collection-result/${data.id}`);
                return;
            }
            // fallback
            setFinishModalVisible(true);
        } catch (error) {
            console.error('Xatolik:', error);
            // [FIX] Xatolikda ham localStorage tozalanadi — cheksiz loop oldini olinadi
            cleanupLocalStorage();
            setFinishModalVisible(true);
        } finally {
            finishingRef.current = false;
        }
    }, [id, navigate, cleanupLocalStorage]);

    // [UTILS] steplar ichidan mavjud keyingi stepni topish
    const getNextStepWithQuestions = useCallback((fromStep) => {
        const savedSteps = JSON.parse(localStorage.getItem('steps') || '{}');
        const has = (k) => savedSteps && savedSteps[k] && Object.keys(savedSteps[k] || {}).length > 0;
        const exclude = new Set([fromStep, ...(doneSteps || [])]);
        // faqat oldinga (fromStep+1 → 4), WRAP-AROUND YO‘Q
        const order = [fromStep + 1, fromStep + 2, fromStep + 3, fromStep + 4].filter(v => v <= 4);
        return order.find(k => !exclude.has(k) && has(k)) || null;
    }, [doneSteps]);

    useEffect(() => {
        if (pages.length > 0) {
            setCanGoNext(!!getNextStepWithQuestions(step));
        }
    }, [pages, step, getNextStepWithQuestions]);

    // [NEW] stepga o'tish (pauza tugaganda)
    const applyStep = useCallback((toStep) => {
        const savedSteps = JSON.parse(localStorage.getItem('steps') || '{}');
        const q = savedSteps[toStep] ?? {};

        // 🔒 yana bir bor tozalash (idempotent)
        try {
            localStorage.removeItem("selectedPageKey");
        } catch (_) {
        }

        setStep(toStep);
        setQuestions(q);
        setCurrent(1);
        setCurrentQuestion(q[1]);
        setSplit(q[1]?.split ?? false);
        setBreakOpen(false);
        setBreakUntil(null);
        setPendingStep(null);

        // ⏲️ break tugaganidan keyin keyingi step uchun yangi deadline ochamiz
        ensureDeadlineForStep(toStep);
    }, [ensureDeadlineForStep]);

    // [NEW] 5s pauzani boshlash
    const startBreakToStep = useCallback((toStep) => {
        const savedSteps = JSON.parse(localStorage.getItem('steps') || '{}');
        const nextQ = savedSteps[toStep] ?? {};
        const count = Object.keys(nextQ || {}).length;
        const minutes = STEP_MINUTES[toStep] || 30;

        setPendingStep(toStep);
        setBreakInfo({count, minutes, step: toStep});
        setBreakOpen(true);
        const until = Date.now() + STEP_BREAK_MS;
        setBreakUntil(until);
    }, []);

    // [NEW] pauza sanog‘i tugaganda avtomatik o‘tish
    useEffect(() => {
        if (!breakOpen || !breakUntil) return;
        let rafId;
        const tick = () => {
            if (Date.now() >= breakUntil) {
                applyStep(pendingStep);
                return;
            }
            rafId = requestAnimationFrame(tick);
        };
        rafId = requestAnimationFrame(tick);
        return () => cancelAnimationFrame(rafId);
    }, [breakOpen, breakUntil, pendingStep, applyStep]);

    // [NEW] joriy step vaqti tugaganda
    const handleStepTimeUp = useCallback(() => {
        // Joriy stepni tugallangan sifatida belgilaymiz
        setDoneSteps(prev => (prev?.includes(step) ? prev : [...prev, step]));
        const next = getNextStepWithQuestions(step);
        if (next) {
            startBreakToStep(next);
            return;
        }
        setFinishMessage("Vaqtingiz tugadi! Natija telegram orqali yuboriladi!");
        handleFinish();
    }, [step, getNextStepWithQuestions, startBreakToStep, handleFinish]);

    // Review dan “Next Step”
    const handleGoNextFromReview = useCallback(() => {
        setReviewOpen(false);

        const next = getNextStepWithQuestions(step);
        if (!next) return;
        setDoneSteps(prev => (prev?.includes(step) ? prev : [...prev, step]));
        // 🔄 1) LocalStorage cleanup: paginator tanlovi va keyingi step taymeri
        try {
            localStorage.removeItem("selectedPageKey");      // paginator highlight tozalanadi
            localStorage.removeItem(`deadline_s${next}`);    // keyingi step uchun har doim yangi 30min yaratiladi
        } catch (_) {
        }

        // 🧽 2) UI ni “neutral” holatga keltiramiz (hozir break ochiladi)
        setCurrent(1);          // keyingi stepga o‘tganda baribir 1-bo‘lib ochiladi
        setDeadline(undefined); // headerda eski countdown ko‘rinmasin

        // ⏸️ 3) 5s pauzani ishga tushiramiz
        localStorage.removeItem("selectedPageKey");
        setCurrent(1);
        setPages([]);
        setQuestions({});
        setCurrentQuestion(undefined);
        setSplit(false);
        startBreakToStep(next);
    }, [getNextStepWithQuestions, step, startBreakToStep]);

    // Review modal uchun flag
    const [canGoNext, setCanGoNext] = useState(false);

    useEffect(() => {
        if (pages.length > 0) {
            setCanGoNext(!!getNextStepWithQuestions(step));
        }
    }, [pages, step, getNextStepWithQuestions]);

    const handleBreakFinish = useCallback(() => {
        if (pendingStep) applyStep(pendingStep);
    }, [pendingStep, applyStep]);

    useEffect(() => {
        localStorage.setItem('selectedPageKey', String(current));
    }, [current]);

    return (
        <div>
            <Card>
                {/* Header: Start bosilgandan keyin taymer va Stop (Review) */}
                <div style={{
                    position: 'fixed',
                    top: 0, left: 0, right: 0,
                    height: 85, padding: 10, background: '#fff',
                    borderBottom: '1px solid #eee', zIndex: 90, textAlign: 'center', marginBottom: 15
                }}>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: 12,
                        marginTop: 24
                    }}>
                        {/* Taymer faqat startdan keyin va pauza emas paytda */}
                        {!modalVisible && !breakOpen && deadline && (
                            <Countdown
                                key={`cd-${step}`}
                                value={deadline}
                                onFinish={handleStepTimeUp}
                                format="HH:mm:ss"
                            />
                        )}
                        <Button danger onClick={() => setReviewOpen(true)}>To'xtatish</Button>
                    </div>
                </div>

                <Splitter
                    key={`${isMobile ? 'm' : 'd'}-${split ? 's' : 'n'}`}  // split ham kiritildi
                    style={{boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)'}}
                >
                    <Splitter.Panel
                        defaultSize={isMobile ? 0 : (split ? '50%' : 0)}
                        min={isMobile ? 0 : '20%'}
                        max={'70%'}
                    >
                        <div style={{fontSize: "clamp(16px, 4vw, 20px)", marginTop: 90}}>
                            <MathText text={currentQuestion?.leftsideText} isMobile={isMobile}/>
                        </div>
                    </Splitter.Panel>

                    <Splitter.Panel>
                        <div style={{marginTop: '80px', marginBottom: '80px', padding: '10px'}}>
                            <Text style={{fontSize: "clamp(16px, 4vw, 20px)", fontFamily: "Times New Roman"}} strong>
                                {current} - savol ({MODULE_TITLES[step]})
                            </Text>

                            <div style={{fontSize: "clamp(16px, 4vw, 20px)", marginTop: 10}}>
                                <MathText
                                    key={`body-${currentQuestion?.id || 'x'}`}
                                    text={currentQuestion?.content}
                                    isMobile={isMobile}
                                />
                            </div>

                            {currentQuestion?.writable ? (
                                <div style={{marginTop: 16}}>
                                    <div style={{marginTop: 16}}>
                                        <MathAnswerInput
                                            value={answers[currentQuestion?.id] ?? ""}
                                            onChange={(val) => {

                                                const qid = currentQuestion?.id;

                                                if (!qid) return;
                                                setAnswers(prev => ({...prev, [qid]: val}));

                                            }}
                                        />

                                    </div>
                                </div>
                            ) : (
                                ["variant1", "variant2", "variant3", "variant4"].map((key, idx) => (
                                    <Card.Grid
                                        key={key}
                                        style={{
                                            width: '100%', marginTop: 10, textAlign: 'left', cursor: 'pointer',
                                            border: answers[currentQuestion?.id] === key ? '2px solid #1677ff' : undefined,
                                            color: answers[currentQuestion?.id] === key ? '#1677ff' : undefined,
                                            display: 'flex', borderRadius: 8
                                        }}
                                        onClick={() => setAnswers(prev => ({...prev, [currentQuestion?.id]: key}))}
                                    >
                                        <div style={{
                                            display: "inline-flex", justifyContent: "center", alignItems: "center",
                                            width: "30px", height: "30px", border: "1px solid",
                                            borderColor: answers[currentQuestion?.id] === key ? '#1677ff' : '#f0f0f0ff',
                                            borderRadius: "50%", fontFamily: "Arial, sans-serif", marginRight: "10px"
                                        }}>
                                            {String.fromCharCode(65 + idx)}
                                        </div>
                                        <div style={{fontSize: "clamp(18px, 4vw, 22px)"}}>
                                            <MathText key={`opt-${currentQuestion?.id}-${key}`}
                                                      text={currentQuestion?.[key] || ""}
                                                      isMobile={isMobile}
                                            />
                                        </div>
                                    </Card.Grid>
                                ))
                            )}
                        </div>
                    </Splitter.Panel>
                </Splitter>

                {/* Bottom sticky: mobile left text opener */}
                <div
                    style={{
                        position: 'fixed', left: 0, right: 0, bottom: 90, height: 60,
                        zIndex: 90, background: '#fafcff',
                        display: isMobile ? (split ? 'flex' : 'none') : 'none',
                        alignItems: 'center', justifyContent: 'center', padding: '0 16px',
                        boxSizing: 'border-box', width: '100vw', borderTop: '1px solid #eee',
                    }}
                    onClick={handleTextOpen}
                >
                    <div style={{
                        width: '100%', display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: '2',
                        overflow: 'hidden', textOverflow: 'ellipsis', fontSize: 16, lineHeight: 1.35,
                        wordBreak: 'break-word', whiteSpace: 'normal'
                    }}>
                        <MathText text={currentQuestion?.leftsideText} isMobile={isMobile}/>
                    </div>
                </div>

                {/* Paginator */}
                <div
                    style={{
                        position: 'fixed', bottom: 0, left: 0, right: 0, padding: 12,
                        background: '#fff', borderTop: '1px solid #eee', zIndex: 100
                    }}
                >
                    <div style={{display: "flex"}}>
                        <div style={{
                            display: "inline-table", padding: "12px 0px 12px 12px",
                            scrollbarWidth: "none", boxShadow: "3px 0 1px -1px rgba(0, 0, 0, 0.15)", zIndex: 10
                        }}>
                            <Button className="left-button nav-button" onClick={scrollLeft}><LeftOutlined/></Button>
                        </div>

                        <TesterPaginator
                            pages={pages}
                            setCurrent={setCurrent}
                            answers={answers}
                            finish={finishModalVisible}
                            scrollRef={scrollRef}
                        />

                        <div style={{
                            display: "inline-table", padding: "12px 12px 12px 0px",
                            scrollbarWidth: "none", boxShadow: "-3px 0 1px -1px rgba(0, 0, 0, 0.15)", zIndex: 10
                        }}>
                            <Button className="left-button nav-button" onClick={scrollRight}><RightOutlined/></Button>
                        </div>
                    </div>
                </div>
            </Card>

            {/* Mobile Drawer for left text */}
            <Drawer
                closable={false}
                destroyOnHidden
                zIndex={95}
                placement="bottom"
                open={textOpen}
                height="60vh"
                rootStyle={{bottom: 80}}
                onClose={() => setTextOpen(false)}
                styles={{body: {padding: 0}}}
            >
                <button
                    onClick={() => setTextOpen(false)}
                    style={{
                        position: "absolute", top: 7, right: 16, zIndex: 10,
                        background: "none", border: "none", fontSize: 24, cursor: "pointer"
                    }}
                    aria-label="Yopish"
                >
                    <CloseOutlined/>
                </button>
                <div style={{
                    padding: "32px 16px 16px 16px",
                    textAlign: "justify",
                    fontSize: 16,
                    lineHeight: 1.7,
                    height: "100%",
                    overflow: "auto"
                }}>
                    <MathText key={`left-${currentQuestion?.id || 'x'}`} text={currentQuestion?.leftsideText}
                              isMobile={isMobile}/>
                </div>
            </Drawer>

            {/* Start modal */}
            <StartModal modalVisible={modalVisible} setModalVisible={setModalVisible}/>

            {/* Finish modal */}
            <FinishModal
                modalVisible={finishModalVisible}
                setModalVisible={setFinishModalVisible}
                finishMessage={finishMessage}
            />

            {/* Review modal (Stop) */}
            <ReviewModal
                open={reviewOpen}
                onClose={() => setReviewOpen(false)}
                onSubmit={() => {
                    setReviewOpen(false);
                    setFinishMessage("Natija telegram orqali yuboriladi!");
                    handleFinish();
                }}
                pages={pages}
                answers={answers}
                setCurrent={setCurrent}
                finish={finishModalVisible}
                moduleTitle={`Module ${step}: Questions`}
                canGoNext={canGoNext}
                onNextStep={handleGoNextFromReview}
            />

            {/* [NEW] Step-lar orasidagi 5s pauza modali */}
            <Modal
                open={breakOpen}
                footer={null}
                closable={false}
                centered
                maskClosable={false}
                keyboard={false}
                styles={{
                    body: {textAlign: 'center', padding: 32},
                    mask: {backdropFilter: "blur(8px)", backgroundColor: "rgba(0,0,0,0.35)"},
                }}
            >
                <Typography.Title level={2} style={{marginBottom: 0}}>
                    Next: Module {breakInfo.step}
                </Typography.Title>
                <div style={{marginTop: 8, fontSize: 16}}>
                    Questions: <b>{breakInfo.count}</b> &nbsp;•&nbsp; Time: <b>{breakInfo.minutes} minutes</b>
                </div>
                <div style={{marginTop: 16}}>
                    <Text type="secondary">Starting in</Text>
                    <div style={{marginTop: 8}}>
                        {breakUntil && (
                            <Countdown
                                key={`break-${breakInfo.step}-${breakUntil}`}
                                value={breakUntil}
                                format="ss"
                                suffix="s"
                                onFinish={handleBreakFinish}
                            />
                        )}
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default SatCollectionTest;
